// FirstPromoter affiliate attribution helpers.
// The tracking script (fpr.js) is initialized globally in public/index.html with
// the public account id (cid) so referral clicks are captured on the landing page
// before registration. This module only READS the resulting visitor state and
// notifies signups. It never initializes FirstPromoter (avoids double init).

// Returns the current FirstPromoter visitor tracking id (tid) for a referred
// visitor, or null if there is no referral. fp_tid is attribution metadata only;
// it is NOT the internal user id and must never be trusted for auth/pricing/credits.
export function getReferralTid() {
  if (typeof window === "undefined") return null;
  try {
    const tid = window.FPROM && window.FPROM.data && window.FPROM.data.tid;
    if (typeof tid === "string" && tid.trim()) return tid.trim();
    const cookie = (document.cookie.split(";").map((c) => c.trim()).find((c) => c.startsWith("_fprom_tid=")) || "").split("=")[1];
    return cookie && cookie.trim() ? decodeURIComponent(cookie.trim()) : null;
  } catch {
    return null;
  }
}

// Associates a signup with the affiliate referral using the stable internal uid.
// No-op if the tracking script is unavailable (blocked/not loaded). Never sends
// sensitive business/audit/architect content.
export function trackReferralSignup({ email, uid }) {
  if (typeof window === "undefined" || typeof window.fpr !== "function") return;
  if (!uid) return;
  window.fpr("referral", { email, uid: String(uid) });
}
